import React, { useState, useEffect } from "react";
import axios from "axios";
import Timer from "react-compound-timer";
import ReactModal from "react-modal";

ReactModal.setAppElement("#root");

function Hard({ setPhase }) {
  const [showModal, setShowModal] = useState(false);

  const abc = "abcdefghijklmnopqrstuvwyz";
  const [wordCount, setWordCount] = useState(0);
  const [min, setMin] = useState(0);
  const [sec, setSec] = useState(0);
  const [lang, setLang] = useState("es");

  const [timer, setTimer] = useState(0);

  const [words, setWords] = useState([]);

  const [letters, setLetters] = useState([]);
  const [firstRowFirstItem, setFirstRowFirstItem] = useState(false);

  let firstLetter = Math.floor(Math.random() * abc.length);
  const [firstRowFirstItemLetter, setFirstRowFirstItemLetter] = useState(
    abc[firstLetter]
  );

  const [secondRowFirstItem, setSecondRowFirstItem] = useState(false);
  let secondLetter = Math.floor(Math.random() * abc.length);
  const [secondRowFirstItemLetter, setSecondRowFirstItemLetter] = useState(
    abc[secondLetter]
  );

  const [secondRowSecondItem, setSecondRowSecondItem] = useState(false);
  let thirdLetter = Math.floor(Math.random() * abc.length);
  const [secondRowSecondItemLetter, setSecondRowSecondItemLetter] = useState(
    abc[thirdLetter]
  );

  const [thirdRowFirstItem, setThirdRowFirstItem] = useState(false);
  let fourthLetter = Math.floor(Math.random() * abc.length);
  const [thirdRowFirstItemLetter, setThirdRowFirstItemLetter] = useState(
    abc[fourthLetter]
  );

  const [thirdRowSecondItem, setThirdRowSecondItem] = useState(false);
  let fifthLetter = Math.floor(Math.random() * abc.length);
  const [thirdRowSecondItemLetter, setthirdRowSecondItemLetter] = useState(
    abc[fifthLetter]
  );

  const [thirdRowThirdItem, setThirdRowThirdItem] = useState(false);
  let sixthLetter = Math.floor(Math.random() * abc.length);
  const [thirdRowThirdItemLetter, setthirdRowThirdItemLetter] = useState(
    abc[sixthLetter]
  );

  const [fourthRowFirstItem, setFourthRowFirstItem] = useState(false);
  let seventhLetter = Math.floor(Math.random() * abc.length);
  const [fourthRowFirstItemLetter, setFourthRowFirstItemLetter] = useState(
    abc[seventhLetter]
  );

  const [fourthRowSecondItem, setFourthRowSecondItem] = useState(false);
  let eighthLetter = Math.floor(Math.random() * abc.length);
  const [fourthRowSecondItemLetter, setFourthRowSecondItemLetter] = useState(
    abc[eighthLetter]
  );

  const [fifthRowFirstItem, setFifthRowFirstItem] = useState(false);
  let ninethLetter = Math.floor(Math.random() * abc.length);
  const [fifthRowFirstItemLetter, setFifthRowFirstItemLetter] = useState(
    abc[ninethLetter]
  );

  useEffect(() => {
    let min = localStorage.getItem("min");
    let sec = localStorage.getItem("sec");
    let lang = localStorage.getItem("lang");

    setMin(min);
    setSec(sec);
    setLang(lang);
  }, []);

  const handleBack = () => {
    setPhase("timer");
    localStorage.setItem("phase", "timer");
  };

  const handleOut = () => {
    setPhase("main");
    localStorage.setItem("phase", "main");
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  setTimeout(
    function() {
      setShowModal(true);
    }.bind(this),
    (localStorage.getItem("min") * 60 + localStorage.getItem("sec")) * 1000 +
      1000
  );

  // 1

  const handleClickFirstsRowFirstItem = () => {
    if (firstRowFirstItem) {
      setLetters(letters.filter(letter => letter !== firstRowFirstItemLetter));
      setFirstRowFirstItem(!firstRowFirstItem);
    } else {
      if (letters.length === 0) {
        setLetters([...letters, firstRowFirstItemLetter]);
        setFirstRowFirstItem(!firstRowFirstItem);
      } else {
        if (
          letters.includes(secondRowFirstItemLetter) ||
          letters.includes(secondRowSecondItemLetter)
        ) {
          setLetters([...letters, firstRowFirstItemLetter]);
          setFirstRowFirstItem(!firstRowFirstItem);
        }
      }
    }
  };

  // 2

  const handleClickSecondRowFirstItem = () => {
    if (secondRowFirstItem) {
      if (letters[letters.length - 1] === secondRowFirstItemLetter) {
        setLetters(
          letters.filter(letter => letter !== secondRowFirstItemLetter)
        );
        setSecondRowFirstItem(!secondRowFirstItem);
      }
    } else {
      if (letters.length === 0) {
        setLetters([...letters, secondRowFirstItemLetter]);
        setSecondRowFirstItem(!secondRowFirstItem);
      } else {
        if (
          letters.includes(firstRowFirstItemLetter) ||
          letters.includes(secondRowSecondItemLetter) ||
          letters.includes(thirdRowFirstItemLetter) ||
          letters.includes(thirdRowSecondItemLetter)
        ) {
          setLetters([...letters, secondRowFirstItemLetter]);
          setSecondRowFirstItem(!secondRowFirstItem);
        }
      }
    }
  };

  // 3

  const handleClickSecondRowSecondItem = () => {
    if (secondRowSecondItem) {
      if (letters[letters.length - 1] === secondRowSecondItemLetter) {
        setLetters(
          letters.filter(letter => letter !== secondRowSecondItemLetter)
        );
        setSecondRowSecondItem(!secondRowSecondItem);
      }
    } else {
      if (letters.length === 0) {
        setLetters([...letters, secondRowSecondItemLetter]);
        setSecondRowSecondItem(!secondRowSecondItem);
      } else {
        if (
          letters.includes(firstRowFirstItemLetter) ||
          letters.includes(secondRowFirstItemLetter) ||
          letters.includes(thirdRowSecondItemLetter) ||
          letters.includes(thirdRowThirdItemLetter)
        ) {
          setLetters([...letters, secondRowSecondItemLetter]);
          setSecondRowSecondItem(!secondRowSecondItem);
        }
      }
    }
  };

  // 4

  const handleClickThirdRowFirstItem = () => {
    if (thirdRowFirstItem) {
      if (letters[letters.length - 1] === thirdRowFirstItemLetter) {
        setLetters(
          letters.filter(letter => letter !== thirdRowFirstItemLetter)
        );
        setThirdRowFirstItem(!thirdRowFirstItem);
      }
    } else {
      if (letters.length === 0) {
        setLetters([...letters, thirdRowFirstItemLetter]);
        setThirdRowFirstItem(!thirdRowFirstItem);
      } else {
        if (
          letters.includes(secondRowFirstItemLetter) ||
          letters.includes(fourthRowFirstItemLetter) ||
          letters.includes(thirdRowSecondItemLetter)
        ) {
          setLetters([...letters, thirdRowFirstItemLetter]);
          setThirdRowFirstItem(!thirdRowFirstItem);
        }
      }
    }
  };

  // 5

  const handleClickThirdRowSecondItem = () => {
    if (thirdRowSecondItem) {
      if (letters[letters.length - 1] === thirdRowSecondItemLetter) {
        setLetters(
          letters.filter(letter => letter !== thirdRowSecondItemLetter)
        );
        setThirdRowSecondItem(!thirdRowSecondItem);
      }
    } else {
      if (letters.length === 0) {
        setLetters([...letters, thirdRowSecondItemLetter]);
        setThirdRowSecondItem(!thirdRowSecondItem);
      } else {
        if (
          letters.includes(secondRowFirstItemLetter) ||
          letters.includes(secondRowSecondItemLetter) ||
          letters.includes(thirdRowFirstItemLetter) ||
          letters.includes(thirdRowThirdItemLetter) ||
          letters.includes(fourthRowFirstItemLetter) ||
          letters.includes(fourthRowSecondItemLetter)
        ) {
          setLetters([...letters, thirdRowSecondItemLetter]);
          setThirdRowSecondItem(!thirdRowSecondItem);
        }
      }
    }
  };

  // 6

  const handleClickThirdRowThirdItem = () => {
    if (thirdRowThirdItem) {
      if (letters[letters.length - 1] === thirdRowThirdItemLetter) {
        setLetters(
          letters.filter(letter => letter !== thirdRowThirdItemLetter)
        );
        setThirdRowThirdItem(!thirdRowThirdItem);
      }
    } else {
      if (letters.length === 0) {
        setLetters([...letters, thirdRowThirdItemLetter]);
        setThirdRowThirdItem(!thirdRowThirdItem);
      } else {
        if (
          letters.includes(secondRowSecondItemLetter) ||
          letters.includes(fourthRowSecondItemLetter) ||
          letters.includes(thirdRowSecondItemLetter)
        ) {
          setLetters([...letters, thirdRowThirdItemLetter]);
          setThirdRowThirdItem(!thirdRowThirdItem);
        }
      }
    }
  };

  // 7

  const handleClickFourthRowFirstItem = () => {
    if (fourthRowFirstItem) {
      if (letters[letters.length - 1] === fourthRowFirstItemLetter) {
        setLetters(
          letters.filter(letter => letter !== fourthRowFirstItemLetter)
        );
        setFourthRowFirstItem(!fourthRowFirstItem);
      }
    } else {
      if (letters.length === 0) {
        setLetters([...letters, fourthRowFirstItemLetter]);
        setFourthRowFirstItem(!fourthRowFirstItem);
      } else {
        if (
          letters.includes(fifthRowFirstItemLetter) ||
          letters.includes(fourthRowSecondItemLetter) ||
          letters.includes(thirdRowFirstItemLetter) ||
          letters.includes(thirdRowSecondItemLetter)
        ) {
          setLetters([...letters, fourthRowFirstItemLetter]);
          setFourthRowFirstItem(!fourthRowFirstItem);
        }
      }
    }
  };

  // 8

  const handleClickFourthRowSecondItem = () => {
    if (fourthRowSecondItem) {
      if (letters[letters.length - 1] === fourthRowSecondItemLetter) {
        setLetters(
          letters.filter(letter => letter !== fourthRowSecondItemLetter)
        );
        setFourthRowSecondItem(!fourthRowSecondItem);
      }
    } else {
      if (letters.length === 0) {
        setLetters([...letters, fourthRowSecondItemLetter]);
        setFourthRowSecondItem(!fourthRowSecondItem);
      } else {
        if (
          letters.includes(fifthRowFirstItemLetter) ||
          letters.includes(fourthRowFirstItemLetter) ||
          letters.includes(thirdRowSecondItemLetter) ||
          letters.includes(thirdRowThirdItemLetter)
        ) {
          setLetters([...letters, fourthRowSecondItemLetter]);
          setFourthRowSecondItem(!fourthRowSecondItem);
        }
      }
    }
  };

  // 9

  const handleClickFifthRowFirstItem = () => {
    if (fifthRowFirstItem) {
      if (letters[letters.length - 1] === fifthRowFirstItemLetter) {
        setLetters(
          letters.filter(letter => letter !== fifthRowFirstItemLetter)
        );
        setFifthRowFirstItem(!fifthRowFirstItem);
      }
    } else {
      if (letters.length === 0) {
        setLetters([...letters, fifthRowFirstItemLetter]);
        setFifthRowFirstItem(!fifthRowFirstItem);
      } else {
        if (
          letters.includes(fourthRowFirstItemLetter) ||
          letters.includes(fourthRowSecondItemLetter)
        ) {
          setLetters([...letters, fifthRowFirstItemLetter]);
          setFifthRowFirstItem(!fifthRowFirstItem);
        }
      }
    }
  };

  // Llamamos a Rae
  const handleClickBtn = async () => {
    let word = letters.join("");

    // Buscar en API
    try {
      let response = await axios.get(
        `https://${lang}.wikipedia.org/api/rest_v1/page/title/${word}`
      );
      // Exito
      if (response.status === 200) {
        if (!words.includes(word)) {
          setWords([...words, word]);
          setWordCount(wordCount + 1);
        }
      }
    } catch (e) {
      console.log("Error");
    }

    setLetters([]);
    setFirstRowFirstItem(false);
    setSecondRowFirstItem(false);
    setSecondRowSecondItem(false);
    setThirdRowFirstItem(false);
    setThirdRowSecondItem(false);
    setThirdRowThirdItem(false);
    setFourthRowFirstItem(false);
    setFourthRowSecondItem(false);
    setFifthRowFirstItem(false);

    // Fin
  };

  return (
    <div className="container game-stage">
      {localStorage.getItem("min") + localStorage.getItem("sec") != 0
        ? <ReactModal
            isOpen={showModal}
            contentLabel="Modal..."
            onRequestColse={() => setShowModal(false)}
            className="modal"
            overlayClassName="overlay"
          >
            <h1>Game over</h1>
            <p>
              Nivel: Difícil <br />
              Palabras encontradas: {wordCount}
              <br />
            </p>
            <h3 onClick={() => handleRefresh()}>Jugar de nuevo</h3>
            <h3 onClick={() => handleOut()}>Salir</h3>
          </ReactModal>
        : null}
      <button className="btn-back btn-white" onClick={() => handleBack()}>
        <i className="fas fa-arrow-left" />
      </button>
      <button className="btn-refresh btn-white" onClick={() => handleRefresh()}>
        <i className="fas fa-sync-alt" />
      </button>
      <div className="easy">
        <div className="scores">
          <div className="solved">
            <div className="solvedIconBG">
              <div className="solvedIcon">
                <div className="solvedIconDiv">
                  <span className="fa fa-star yellow" />
                </div>
              </div>
            </div>
          </div>
          <div className="wordCount">
            {wordCount}
          </div>
          <div className="level">
            <h2>Difícil</h2>
          </div>
          <div className="timerCount">
            <Timer
              timeToUpdate={0}
              initialTime={
                (parseInt(localStorage.getItem("min") * 60) +
                  parseInt(localStorage.getItem("sec"))) *
                  1000 +
                1000
              }
              formatValue={value => `${value < 10 ? `0${value}` : value}`}
              direction="backward"
            >
              {() =>
                <React.Fragment>
                  <Timer.Minutes
                    formatValue={value => `${value < 10 ? `0${value}` : value}`}
                  />:<Timer.Seconds
                    formatValue={value => `${value < 10 ? `0${value}` : value}`}
                  />
                </React.Fragment>}
            </Timer>
          </div>
          <div className="timer">
            <div className="timerIconBG">
              <div className="timerIcon">
                <div className="timerIconDiv">
                  <span className="fa fa-pause pink" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <section className="tl">
          <article
            className={firstRowFirstItem ? "pressed" : null}
            onClick={() => handleClickFirstsRowFirstItem()}
          >
            <figure>
              <h3>
                {firstRowFirstItemLetter}
              </h3>
            </figure>
          </article>
          <article
            className={secondRowFirstItem ? "pressed" : null}
            onClick={() => handleClickSecondRowFirstItem()}
          >
            <figure>
              <h3>
                {secondRowFirstItemLetter}
              </h3>
            </figure>
          </article>
          <article
            className={secondRowSecondItem ? "pressed" : null}
            onClick={() => handleClickSecondRowSecondItem()}
          >
            <figure>
              <h3>
                {secondRowSecondItemLetter}
              </h3>
            </figure>
          </article>
          <article
            className={thirdRowFirstItem ? "pressed" : null}
            onClick={() => handleClickThirdRowFirstItem()}
          >
            <figure>
              <h3>
                {thirdRowFirstItemLetter}
              </h3>
            </figure>
          </article>
          <article
            className={thirdRowSecondItem ? "pressed" : null}
            onClick={() => handleClickThirdRowSecondItem()}
          >
            <figure>
              <h3>
                {thirdRowSecondItemLetter}
              </h3>
            </figure>
          </article>
          <article
            className={thirdRowThirdItem ? "pressed" : null}
            onClick={() => handleClickThirdRowThirdItem()}
          >
            <figure>
              <h3>
                {thirdRowThirdItemLetter}
              </h3>
            </figure>
          </article>
          <article
            className={fourthRowFirstItem ? "pressed" : null}
            onClick={() => handleClickFourthRowFirstItem()}
          >
            <figure>
              <h3>
                {fourthRowFirstItemLetter}
              </h3>
            </figure>
          </article>
          <article
            className={fourthRowSecondItem ? "pressed" : null}
            onClick={() => handleClickFourthRowSecondItem()}
          >
            <figure>
              <h3>
                {fourthRowSecondItemLetter}
              </h3>
            </figure>
          </article>
          <article
            className={fifthRowFirstItem ? "pressed" : null}
            onClick={() => handleClickFifthRowFirstItem()}
          >
            <figure>
              <h3>
                {fifthRowFirstItemLetter}
              </h3>
            </figure>
          </article>
        </section>
        {words.length > 0 &&
          <div className="words-found">
            {words.map(word =>
              <span className="word-found" key={word}>
                {word}
              </span>
            )}
          </div>}
        {letters.length > 0 &&
          <div className="letters-selected">
            <h4>
              {letters}{" "}
              {letters.length >= 3 &&
                <button className="check" onClick={() => handleClickBtn()}>
                  <i className="fas fa-search" />
                </button>}
            </h4>
          </div>}
      </div>
    </div>
  );
}

export default Hard;
